import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./CrewPilotToast.css";

const DEFAULT_DISMISS_MS = 3500;

export function CrewPilotToast({
  message,
  onDismiss,
  autoDismissMs = DEFAULT_DISMISS_MS,
  dontShowAgainLabel,
}) {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const hasCheckbox = Boolean(dontShowAgainLabel);

  useEffect(() => {
    if (!onDismiss) return undefined;

    const timer = setTimeout(() => {
      if (hasCheckbox) {
        onDismiss({ dontShowAgain });
      } else {
        onDismiss();
      }
    }, autoDismissMs);
    return () => clearTimeout(timer);
  }, [autoDismissMs, onDismiss, message, hasCheckbox, dontShowAgain]);

  if (!message || typeof document === "undefined") return null;

  return createPortal(
    <div
      className={`cp-toast${hasCheckbox ? " cp-toast--interactive" : ""}`}
      role="status"
      aria-live="polite"
    >
      <span className="cp-toast-icon" aria-hidden="true">
        ✅
      </span>
      {hasCheckbox ? (
        <div className="cp-toast-content">
          <span className="cp-toast-message">{message}</span>
          <label className="cp-toast-checkbox">
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={(event) => setDontShowAgain(event.target.checked)}
            />
            {dontShowAgainLabel}
          </label>
        </div>
      ) : (
        <span className="cp-toast-message">{message}</span>
      )}
    </div>,
    document.body,
  );
}
